import { useState } from 'react';
import Modal from '../Modal';
import Button from '../Button';
import Alert from '../Alert';
import { enableEnterpriseClasses } from '../../api/admin';

/**
 * 「启用班级分流」弹窗：输入首班名 + 展示「将把 N 名员工归入首班」→ enable。
 *
 * Props:
 *   entId          企业 id
 *   employeeCount  当前企业员工数（口径与后端 enable 全员归班一致）
 *   onClose        关闭
 *   onDone         成功回调（父级据此刷新企业形态）
 */
export default function EnableClassesModal({ entId, employeeCount = 0, onClose, onDone }) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim()) { setError('请输入班级名称'); return; }
    setSaving(true); setError('');
    try {
      await enableEnterpriseClasses(entId, { first_class_name: name.trim() });
      onDone?.();
    } catch (e) {
      setError(e.response?.data?.detail || '启用班级分流失败');
      setSaving(false);
    }
  };

  return (
    <Modal
      open
      onClose={onClose}
      title="启用班级分流"
      maxWidth={460}
      footer={
        <>
          <Button variant="secondary" size="sm" onClick={onClose}>取消</Button>
          <Button size="sm" onClick={handleSubmit} loading={saving}>启用</Button>
        </>
      }
    >
      {error && <Alert type="error">{error}</Alert>}
      <Alert type="info">
        将把 {employeeCount} 名员工归入首班。启用后注册码改为带班级编号形态（如 CODE-00），新员工注册后进入对应班级。
      </Alert>
      <div style={{ marginTop: 4 }}>
        <label style={labelStyle}>首班名称</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="如：一班、研发部"
          style={inputStyle}
          autoFocus
        />
      </div>
    </Modal>
  );
}

const labelStyle = { fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 };
const inputStyle = { padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13, width: '100%', boxSizing: 'border-box' };
